"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixtureStatus = void 0;
var FixtureStatus;
(function (FixtureStatus) {
    FixtureStatus[FixtureStatus["Active"] = 0] = "Active";
    FixtureStatus[FixtureStatus["Inactive"] = 1] = "Inactive";
    FixtureStatus[FixtureStatus["Removed"] = 2] = "Removed";
    FixtureStatus[FixtureStatus["Winterized"] = 3] = "Winterized";
})(FixtureStatus = exports.FixtureStatus || (exports.FixtureStatus = {}));
//# sourceMappingURL=FixtureStatus.js.map